<template>
  <div>
    <v-list-item v-if="!isAuthorized">
      <v-list-item-content>
        <v-list-item-title>
          가입코드 <span class="asterisk">*</span>
        </v-list-item-title>
        <v-text-field
          solo
          required
          ref="refMrCode"
          placeholder="가입코드를 입력해 주세요"
          :height="formHeight"
          v-model="userData.mrCode"
          append-icon="mdi-check"
          :rules="[requiredRuleByItem('가입코드')]"
         />
        <span class="input-guide">
           • 영업담당자를 통해 전달받은 가입코드를 입력해주시기 바랍니다. <br/>
           • 만약 받지 못하였다면 영업담당자에게 먼저 문의 부탁드립니다.
        </span>
      </v-list-item-content>
    </v-list-item>

    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>아이디 (휴대폰 번호)</v-list-item-title>
          <v-text-field
            v-model="userData.loginId"
            disabled
            solo
            placeholder="본인의 휴대 전화 번호를 입력해 주세요"
            type="tel"
            autofocus
            :rules="[cellRules.required, cellRules.counter, cellRules.check]"
            prepend-inner-icon=""
            class="phone-input"
          >
            <template v-slot:prepend-inner>
              <span class="country-code">+82</span>
            </template>
          </v-text-field>
      </v-list-item-content>
    </v-list-item>

    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>
          성함 <span class="asterisk">*</span>
        </v-list-item-title>
        <v-text-field
          solo
          required
          :disabled="isAuthorized"
          ref="refName"
          placeholder="성함"
          :height="formHeight"
          :rules="[nameRules.required, nameRules.counter, nameRules.check]"
          v-model="userData.name"
          :append-icon="isAuthorized?'':'mdi-check'"
        />
      </v-list-item-content>
    </v-list-item>

  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Cookies from "js-cookie";
import { requiredRuleByItem } from "@/utils/rules.js";
const rulesService = require("@/utils/rules.js");

export default {
  props: {
    userData: {
      type: Object,
    },
  },
  computed: {
    accessInfo() {
      if (!this.isAuthorized) return;
      const CookieName = process.env.VUE_APP_CookieName;
      return JSON.parse(Cookies.get(CookieName));
    },
    ...mapGetters(["isAuthorized", "getThemeMode"]),
  },
  data() {
    return {
      formHeight: 52,
      requiredRuleByItem,
      nameRules: rulesService.nameRules(),
      cellRules: rulesService.cellRules(),
    };
  },
};
</script>
